import { invoiceSchemaResponseSchema } from 'xosign-types';

import { z } from 'zod';
import { API_URL_BASE } from '@/config';
import { type EndpointDefinition } from '@/types/endpointTypes';

const endpoints = {
  'invoices.get.all': {
    method: 'GET',
    url: `${API_URL_BASE}invoices`,
    requestSchema: z.undefined(),
    responseSuccessSchema: invoiceSchemaResponseSchema,
    requiresToken: 'local',
    responseErrorSchemas: z.undefined(),
  } satisfies EndpointDefinition<
    z.ZodUndefined,
    typeof invoiceSchemaResponseSchema,
    z.ZodUndefined
  >,
} as const;

export default endpoints;
